import {
  format,
  isToday,
  isYesterday,
  isWithinInterval,
  subDays,
} from "date-fns";
import { FaTrashAlt } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import utils from "../../business/helper/Utils";
import TruncatedTextWithMenu from "./TruncatedTextWithMenu";
import apiClient from "../../business/network/ApiClient";
import { useEffect, useState } from "react";
import clsx from "clsx";
import { GrtAnalyticsGA4 } from "./GrtAnalyticsGA4";
import star from "../../images/star.svg";
import ListButton from "../design/Shared/ListButton";
import { isMenuDisabled } from "../../business/helper/Singleton";

const DateFormatter = ({ createDateUTC }) => {
  const formattedDate = new Date(createDateUTC).toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return <>({formattedDate})</>;
};

export const FavoritesList = ({
  favorites,
  onFavoriteClick,
  onDelete,
  onRefresh,
}) => {
  const [analytics, setAnalytics] = useState(null);
  const [listCoefficient, setListCoefficient] = useState(5);
  const [isDisabled, setIsDisabled] = useState(isMenuDisabled.state);
  const [loading, setLoading] = useState(true);

  const handleAnalytics = (ga) => {
    if (ga) {
      setAnalytics(ga);
    }
  };

  const handleRename = async (id, newName, ouId) => {
    try {
      var favorite = {};
      favorite.id = Number(id);
      favorite.name = newName;
      favorite.ouId = ouId;

      await apiClient.renameFavorite(favorite);
      await onRefresh();
      console.log("Renamed to:", newName);
      analytics?.trackEventAnalytics("FavoriteMenu", "RenameFavorite", "click");
    } catch (error) {
      console.error("Failed to rename:", error);
      throw error;
    }
  };

  const handleDelete = (id) => {
    onDelete(id);
  };

  useEffect(() => {
    if (favorites) {
      setLoading(false);
    }
  }, [favorites])

  useEffect(() => {
    const event = () => setIsDisabled(isMenuDisabled.state);
    isMenuDisabled.subscribe(event);

    return () => {
      isMenuDisabled.unsubscribe(event);
    };
  }, []);

  useEffect(() => {
    if (favorites?.length < listCoefficient) {
      setListCoefficient(favorites.length > 5 ? favorites.length : 5);
    }
  }, [favorites]);

  return (
    <>
      {!loading &&
        <div className="mb-7">
          {favorites?.length > 0 ?
            <>
              <h3 className="font-semibold text-xl text-dark-blue-100 mb-2 px-1">
                Favorites
              </h3>
              <ul
                className={clsx("list-none bg-white rounded-xl py-4 space-y-1", {
                  "!text-[#969696] !cursor-not-allowed": isDisabled,
                })}>
                {favorites.map((favorite, index) => (
                  <li
                    key={`favorite_today_${index}`}
                    className={clsx(
                      "py-1.5 h-9 items-center pl-6 pr-3 text-[14px] text-dark-blue-100 hover:border-l-4 hover:border-l-[#2A354A] border-l-4 border-l-transparent  whitespace-nowrap cursor-pointer transition-all group hover:bg-whitesmoke-600",
                      {
                        "!h-0 overflow-hidden !m-0 !py-0":
                          index + 1 > listCoefficient,
                      },
                      {
                        "!text-[#969696] !cursor-not-allowed": isDisabled,
                      }
                    )}
                    onClick={() => {
                      !isDisabled && onFavoriteClick(favorite.title);
                    }}
                    data-tooltip-id="tooltipFavorite"
                    data-tooltip-content={favorite.title}
                    data-tooltip-place="right-end"
                    data-tooltip-float
                    data-tooltip-delay-show="300"
                  >
                    <TruncatedTextWithMenu
                      text={favorite.name}
                      onRename={(newName) => {
                        handleRename(favorite.id, newName, favorite.ouId);
                      }}
                      onDelete={() => handleDelete(favorite.id)}
                    />
                  </li>
                ))}

                {favorites.length > 5 && listCoefficient < favorites.length && (
                  <ListButton
                    text="Show more"
                    className={"font-bold"}
                    onClick={() => setListCoefficient((prev) => prev + 8)}
                  />
                )}

                {favorites.length > 5 &&
                  listCoefficient >= favorites.length &&
                  listCoefficient > 5 && (
                    <ListButton
                      text="Show less"
                      className={"font-bold"}
                      onClick={() => setListCoefficient(5)}
                    />
                  )}
              </ul>

            </> : (
              <div className="bg-dimgray-100 text-dimgray-200 py-6 flex items-center justify-center rounded-xl gap-2">
                <img src={star} />
                <p className="text-sl leading-5 capitalize">No Favorites Yet</p>
              </div>
            )}
        </div>}
      <GrtAnalyticsGA4 onLoaded={handleAnalytics} />
    </>
  );
};
